import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export default class ChatQueueClearFrom {
  public date: string = '';

  public rules: { [key: string]: FormValidationFunction[] } = {
    date: [
      (v: string) => !!v || 'Date is required',
    ],
  };
}
